var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevyaniLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 252,
    height: 111.068,
    viewBox: "0 0 252 111.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#62813b;}.b{fill:#88ad4c;}.c{fill:#afd138;}.d{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-249.949 -354.669)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M725.51,355.4c.238,1.741.766,8.515-6.387,13.87-5.8,4.345-6.958,9.454-7.075,11.466,2.667.481,8.257.874,13.215-6.567C730.937,365.658,726.626,357.192,725.51,355.4Z",
    transform: "translate(-226.18 -0.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M723.491,355.317l-.059-.092a15.143,15.143,0,0,1-7.273,12.634,17.973,17.973,0,0,0-8,12.333,7.637,7.637,0,0,0-.137,1.073l1.758.16a7.451,7.451,0,0,1,.011-.772c.12-2.012,1.226-7.2,7.2-11.466C724.431,363.875,723.734,357.058,723.491,355.317Z",
    transform: "translate(-224.208 -0.272)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480.035 354.669)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M738,356.583a12.009,12.009,0,0,0,.106-1.4l-.031-.047A11.2,11.2,0,0,1,738,356.583Z",
    transform: "translate(-718.918 -354.896)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M712.242,365.816c6.893-5.167,7.5-10.428,7.535-10.916-.1-.147-.157-.231-.157-.231-1.725,5.613-11.724,3.8-16.885,10.979-3.968,5.517-1.46,10.334.383,12.713C703.547,375.726,705.336,370.99,712.242,365.816Z",
    transform: "translate(-700.623 -354.669)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(249.949 390.728)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M249.949,426.243a83.642,83.642,0,0,1,13.211-.944c8.492,0,14.356,1.753,18.535,5.257,4.381,3.573,7.077,8.964,7.077,16.716,0,8.088-2.764,14.153-7.077,18.063-4.516,4.111-11.728,6.2-20.557,6.2a90.568,90.568,0,0,1-11.188-.606Zm8.29,38.485a30.82,30.82,0,0,0,4.584.2c10.784.068,17.187-5.864,17.187-17.389.067-10.042-5.729-15.772-16.109-15.772a26.576,26.576,0,0,0-5.662.471Z",
    transform: "translate(-249.949 -425.299)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M361.962,451.235h-17.12v13.344h19.142v6.808H336.552V425.959h26.421v6.808H344.842v11.728h17.12Z",
    transform: "translate(-292.338 -425.622)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M408.275,471.387l-14.693-45.428h9.032l6.2,20.625c1.753,5.729,3.236,11.054,4.449,16.581h.135c1.213-5.393,2.831-10.919,4.651-16.446l6.6-20.759h8.83l-15.7,45.428Z",
    transform: "translate(-320.252 -425.622)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M484.244,471.387v-18.94l-14.356-26.488h9.436l5.459,11.661c1.551,3.369,2.7,5.931,3.909,9.031h.135c1.146-2.9,2.427-5.728,3.977-9.031l5.46-11.661h9.368l-15.1,26.287v19.142Z",
    transform: "translate(-357.601 -425.622)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M544.537,458.514l-3.91,12.873h-8.56l14.558-45.428h10.581l14.761,45.428h-8.9l-4.111-12.873Zm13.008-6.268-3.572-11.189c-.877-2.763-1.618-5.864-2.293-8.493h-.134c-.674,2.629-1.348,5.8-2.157,8.493l-3.5,11.189Z",
    transform: "translate(-388.035 -425.622)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M619.064,471.387V425.959H628.5l11.727,19.479a124.724,124.724,0,0,1,7.751,15.232h.135c-.539-6.067-.741-11.93-.741-18.872V425.959h7.683v45.428H646.5l-11.862-19.951a157.872,157.872,0,0,1-8.155-15.7l-.2.067c.337,5.864.4,11.862.4,19.344v16.244Z",
    transform: "translate(-430.617 -425.622)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M713.034,425.959v45.428h-8.29V425.959Z",
    transform: "translate(-472.554 -425.622)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(250.31 449.036)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M252.745,540.025V556.2h-2.088V540.025Z",
    transform: "translate(-250.657 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M261.185,556.2V540.025h2.28l5.182,8.182a45.819,45.819,0,0,1,2.9,5.255l.048-.024c-.192-2.16-.24-4.127-.24-6.646v-6.767h1.968V556.2h-2.112l-5.135-8.205a51.471,51.471,0,0,1-3.023-5.4l-.072.024c.12,2.039.168,3.982.168,6.67v6.91Z",
    transform: "translate(-255.81 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M292.706,541.8h-4.919v-1.776H299.76V541.8h-4.943v14.4h-2.112Z",
    transform: "translate(-268.831 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M322.433,548.615h-6.286v5.831h7.007V556.2H314.06V540.025h8.733v1.752h-6.646v5.111h6.286Z",
    transform: "translate(-281.69 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M336.478,540.127a21.7,21.7,0,0,1,4.007-.336c2.231,0,3.671.408,4.679,1.319a4.028,4.028,0,0,1,1.272,3.071,4.247,4.247,0,0,1-3.047,4.127v.071c1.248.432,1.992,1.584,2.376,3.264a25.7,25.7,0,0,0,1.248,4.438h-2.16a20.94,20.94,0,0,1-1.08-3.863c-.48-2.232-1.344-3.071-3.239-3.143h-1.967v7.006h-2.088Zm2.088,7.366H340.7c2.232,0,3.647-1.224,3.647-3.071,0-2.088-1.512-3-3.719-3.023a8.6,8.6,0,0,0-2.063.191Z",
    transform: "translate(-292.663 -539.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M361.059,556.2V540.025h2.279l5.183,8.182a45.88,45.88,0,0,1,2.9,5.255l.048-.024c-.192-2.16-.24-4.127-.24-6.646v-6.767H373.2V556.2h-2.112l-5.135-8.205a51.394,51.394,0,0,1-3.023-5.4l-.072.024c.12,2.039.168,3.982.168,6.67v6.91Z",
    transform: "translate(-304.695 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M392.722,551.11l-1.68,5.086h-2.159l5.494-16.172h2.52l5.518,16.172h-2.232l-1.727-5.086Zm5.3-1.631-1.584-4.655c-.36-1.056-.6-2.016-.84-2.951h-.048c-.24.959-.5,1.943-.815,2.927l-1.584,4.679Z",
    transform: "translate(-318.313 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M417.019,541.8H412.1v-1.776h11.973V541.8h-4.943v14.4h-2.112Z",
    transform: "translate(-329.678 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M440.461,540.025V556.2h-2.088V540.025Z",
    transform: "translate(-342.537 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M461.8,547.69c0,5.566-3.383,8.518-7.51,8.518-4.272,0-7.271-3.312-7.271-8.205,0-5.135,3.191-8.495,7.51-8.495C458.946,539.508,461.8,542.891,461.8,547.69Zm-12.549.263c0,3.455,1.872,6.55,5.158,6.55,3.311,0,5.182-3.046,5.182-6.718,0-3.215-1.68-6.574-5.158-6.574C450.98,541.212,449.253,544.4,449.253,547.954Z",
    transform: "translate(-346.77 -539.508)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M480.578,556.2V540.025h2.28l5.183,8.182a45.805,45.805,0,0,1,2.9,5.255l.048-.024c-.192-2.16-.24-4.127-.24-6.646v-6.767h1.967V556.2h-2.111l-5.135-8.205a51.489,51.489,0,0,1-3.023-5.4l-.072.024c.12,2.039.169,3.982.169,6.67v6.91Z",
    transform: "translate(-363.195 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M512.241,551.11l-1.679,5.086H508.4l5.495-16.172h2.519l5.518,16.172H519.7l-1.728-5.086Zm5.3-1.631-1.584-4.655c-.36-1.056-.6-2.016-.84-2.951h-.047c-.24.959-.5,1.943-.816,2.927l-1.583,4.679Z",
    transform: "translate(-376.813 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M538.857,540.025h2.088v14.421h6.91V556.2h-9Z",
    transform: "translate(-391.72 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M569.6,540.025h2.087v14.421h6.91V556.2h-9Z",
    transform: "translate(-406.765 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M593.161,540.025V556.2h-2.087V540.025Z",
    transform: "translate(-417.278 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M614.815,549.1c-.12-2.256-.264-4.967-.24-6.982H614.5c-.552,1.895-1.224,3.911-2.04,6.143l-2.855,7.845h-1.584l-2.614-7.7c-.768-2.28-1.416-4.367-1.872-6.286h-.048c-.048,2.016-.168,4.727-.312,7.15l-.432,6.934h-1.992l1.128-16.172h2.663l2.759,7.822c.672,1.992,1.224,3.767,1.632,5.447h.072c.408-1.633.983-3.407,1.7-5.447l2.879-7.822h2.664l1.007,16.172h-2.039Z",
    transform: "translate(-422.016 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M640.771,540.025V556.2h-2.087V540.025Z",
    transform: "translate(-440.581 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M650.511,541.8h-4.919v-1.776h11.973V541.8h-4.942v14.4h-2.112Z",
    transform: "translate(-443.963 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M680.238,548.615h-6.286v5.831h7.006V556.2h-9.093V540.025H680.6v1.752h-6.646v5.111h6.286Z",
    transform: "translate(-456.822 -539.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M694.283,540.127a29.817,29.817,0,0,1,4.439-.336c3,0,5.134.7,6.551,2.015a7.45,7.45,0,0,1,2.279,5.806,8.559,8.559,0,0,1-2.327,6.287c-1.512,1.511-4.008,2.327-7.151,2.327a33.7,33.7,0,0,1-3.791-.192Zm2.087,14.3a13.206,13.206,0,0,0,2.112.119c4.463,0,6.886-2.494,6.886-6.862.024-3.815-2.136-6.238-6.55-6.238a11.829,11.829,0,0,0-2.448.216Z",
    transform: "translate(-467.795 -539.647)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevyaniLogo);
export default __webpack_public_path__ + "static/media/devyani-logo.a02c6f525e04c345e56e5e0cfa90cf1e.svg";
export { ForwardRef as ReactComponent };